export const LANGUAGE_EN = 'en';
export const LANGUAGE_ZH_CH = 'zh-CN';
export const LANGUAGE_MS = 'ms';